import React from 'react';
import { Col, Form, Modal, Row, Button } from 'react-bootstrap';
import { t } from 'i18next';

const PDFModal = ({
	show,
	close,
	title,
	handleInputChange,
	inputValue,
	inputType,
	handleSubmit,
}) => {
	const handleClose = () => close();

	return (
		<Modal show={show} onHide={handleClose} backdrop="static" centered>
			<Modal.Header closeButton>
				<Modal.Title>{title}</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<Form onSubmit={(e) => { e.preventDefault(); handleSubmit(); }}>
					<Row className="mb-3">
						<Form.Group as={Col} controlId="pdfInput">
							<Form.Label>Enter {title}</Form.Label>
							<Form.Control
								name={title.toLowerCase()}
								type={inputType}
								value={inputValue}
								onChange={handleInputChange}
								placeholder={`Enter ${title}`}
							/>
						</Form.Group>
					</Row>
					<Row className="mb-3">
						<Col className="d-flex justify-content-end">
							<Button type="submit" className="px-3 py-2 me-2" variant="primary" disabled={!inputValue}>
								{t('GENERAL.SUBMIT')}
							</Button>
							<Button variant="danger" className="px-3 py-2" onClick={handleClose}>
								{t('GENERAL.CLOSE')}
							</Button>
						</Col>
					</Row>
				</Form>
			</Modal.Body>
		</Modal>
	);
};

export default PDFModal;
